import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, GridList, GridListTile, Hidden, Typography, withWidth, IconButton, Button } from "@material-ui/core";
import ArrowBackRoundedIcon from "@material-ui/icons/ArrowBackRounded";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import defaultImage from "../../../assets/ic_placeholder.png";
import OutOfStock from "../../../assets/out_of_stock.png";
import { confirm } from "../../../components/ConfirmationDialog/ConfirmationDialog";
import CategoryStore from "../../../Store/CategoryStore";
import productStore from "../../../Store/ProductStore";
import promotionStore from "../../../Store/PromotionStore";
import TenantStore from "../../../Store/TenantStore";
import CustomizedDialogs from "../../../components/FormDialog/FormDialog";

import Img from "../../../components/Img";

import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import StarIcon from '@material-ui/icons/Star';

const useStyles = makeStyles((theme) => ({
    rootImage: {
        flexGrow: 1,
    },
    dialogDetail: {
        maxWidth: "508px",
        height: "auto",
        margin: "auto"
    },
    rootButton: {
        '& > *': {
            margin: theme.spacing(1),
        },
    }
}));

function DetailDialog(props) {
    const {
        title,
        dataMenu,
        deleted,
        approved,
        access,
        handleGetList,
        tabShow,
        width
    } = props;
    const [open, setOpen] = React.useState(true);
    const [, productActions] = productStore();
    const [, promotionActions] = promotionStore();
    const [categoryProductState, categoryProductActions] = CategoryStore();
    const [tenantState, tenantActions] = TenantStore();
    const classes = useStyles();

    const user = JSON.parse(localStorage.getItem("user"));
    const userTenant = user.tenant.id;
    const handleClose = () => {
        setOpen(false);
    };
    const doEdit = () => {
        setOpen(false);
        props.proceed();
    };

    const setStatusRemove = () => {
        confirm(
            `${!deleted ? "Remove Item" : "Restore Item"}`,
            `Are you sure to ${!deleted ? "remove" : "restore"} this item ?`
        ).then(async (onProcess) => {
            if (!deleted) {
                await promotionActions.deletedTenant(dataMenu.id);
            } else {
                const params = [
                    {
                        op: "replace",
                        path: "/deleted ",
                        value: false,
                    },
                ];
                let notif = `Successfully Restore Product`;
            }
            setOpen(false);
            handleGetList(true);
            props.cancel();
        });
    };

    const setStatusApproved = () => {
        confirm(`Approve`, `Are you sure to Approve this item ?`).then(
            async (onProcess) => {
                if (!approved) {
                    await promotionActions.approvedTenant(dataMenu.id, dataMenu);
                } else {
                    const params = [
                        {
                            op: "replace",
                            path: "/deleted ",
                            value: false,
                        },
                    ];
                    let notif = `Successfully Restore Promotion`;
                    // await productActions.patch(dataMenu.id, params, notif);
                }
                setOpen(false);
                handleGetList(true);
                props.cancel();
            }
        );
    };

    const handleOpenDialog = () => {
        var query = {
            num: "200",
            cursor: "",
            position: "",
            search: "",
        };
        categoryProductActions.get(query);
        tenantActions.get(query);
    };

    return (
        <div>
            <Dialog
                maxWidth={width !== "xs" ? "md" : false}
                className={classes.dialogDetail}
                fullScreen={width === "xs"}
                scroll="body"
                open={open}
                onClose={handleClose}
                onEnter={handleOpenDialog}
            >
                <DialogContent style={{ padding: "0px" }}>
                    <Grid container>
                        <Grid item xs={12}>
                            <div style={{ position: "relative", width: "auto" }}>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    onClick={props.handleClose}
                                    aria-label="close"
                                    style={{
                                        backgroundColor: "rgba(0,0,0,0.6)",
                                        color: "#ffffff",
                                        position: "absolute",
                                        top: 25,
                                        left: 25,
                                    }}
                                >
                                    <ArrowBackRoundedIcon />
                                </IconButton>
                                <Img
                                    src={'https://placeimg.com/640/480/tech'}
                                    // alt={dataProperty.name || ""}
                                    style={{ width: "100%", height: "254px" }}
                                />
                            </div>
                        </Grid>

                        {/* image and price */}
                        <Grid item xs={12} style={{ padding: "13px 20px 0px" }} className={classes.rootImage}>
                            <Grid container spacing={4} >

                                <Grid item xs={2} style={{ textAlign: "right" }}>
                                    <Img
                                        src={'https://placeimg.com/640/480/tech'}
                                        // alt={dataProperty.name || ""}
                                        style={{ width: "50px", height: "50px" }}
                                    />
                                </Grid>

                                <Grid item xs={10}>
                                    <Typography style={{ color: "#212121", fontSize: 11 }}>
                                        KFC
                                    </Typography>
                                    <Typography style={{ color: "#212121", fontSize: 20 }}>
                                        Voucher KFC Rp 100.000
                                    </Typography>
                                    <Typography style={{ color: "#2196F3", fontSize: 16 }}>
                                        Rp 90.000 <span style={{ color: "#BDBDBD", fontSize: 11, textDecoration: "line-through" }}>100.000</span>
                                    </Typography>

                                    <p></p>
                                </Grid>
                            </Grid>
                            <Divider />
                        </Grid>
                        {/* image and price end */}


                        {/* status */}
                        <Grid item xs={12} className={classes.rootImage} style={{ padding: "13px 20px 0px" }}>
                            <Grid container spacing={3}>
                                <Grid item xs={8}>
                                    <Typography style={{ color: "#212121", fontSize: 18 }}>
                                        Status
                                    </Typography>
                                    <Typography style={{ color: "#757575", fontSize: 11, lineHeight: 2 }}>
                                        Select a status to change
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} style={{ textAlign: "center", paddingTop: 0 }}>

                                    <div className={classes.rootButton}>
                                        <Button variant="contained" style={{ backgroundColor: "#2196F3", color: "white", height: 38, fontSize: 12 }}>New Request</Button>
                                        <Button variant="contained" style={{ backgroundColor: "#BDBDBD", color: "white", height: 38, fontSize: 12 }}>
                                            On Progress
                                        </Button>
                                        <Button variant="contained" style={{ backgroundColor: "#BDBDBD", color: "white", height: 38, fontSize: 12 }}>
                                            Complete
                                        </Button>

                                    </div>

                                </Grid>

                            </Grid>
                            <Divider style={{ marginTop: '15px' }} />
                        </Grid>

                        {/* status end */}

                        {/* buyer */}
                        <Grid item xs={12} style={{ padding: "13px 20px 0px" }}>
                            <Grid container spacing={3}>
                                <Grid item xs={8}>
                                    <Typography style={{ color: "#212121", fontSize: 18 }}>
                                        Buyer
                                    </Typography>
                                    <Typography style={{ color: "#2196F3", fontSize: 13, paddingTop: 10 }}>
                                        hesa@izy.ai
                                    </Typography>
                                </Grid>

                            </Grid>
                            <Divider style={{ marginTop: "20px" }} />
                        </Grid>
                        {/* buyer end */}

                        {/* history */}
                        <Grid item xs={12} style={{ padding: "13px 20px 60px" }}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography style={{ color: "#212121", fontSize: 18 }}>
                                        History
                                    </Typography>
                                    <List>
                                        <ListItem style={{ padding: 0, }}>
                                            <ListItemIcon style={{ minWidth: 30 }}>
                                                <span style={{
                                                    backgroundColor: "#2196F3",
                                                    borderRadius: "100%",
                                                    width: "8px",
                                                    height: "8px"
                                                }}></span>
                                            </ListItemIcon>
                                            <Typography style={{ color: "#212121", fontSize: 13 }}> New request from <span style={{ color: "#2196F3", fontSize: 13 }}> hesa@izy.ai </span> on <span style={{ color: "#2196F3", fontSize: 13 }}> 30 - 12 - 2020 | 13:00 PM</span>  </Typography>
                                        </ListItem>
                                    </List>

                                </Grid>
                            </Grid>
                        </Grid>
                        {/* history end */}

                    </Grid>

                </DialogContent>
            </Dialog>
        </div >
    );
}
export function showDetail(
    title,
    dataMenu,
    deleted,
    approved,
    tabShow,
    access,
    handleGetList,
    options = {}
) {
    return createConfirmation(confirmable(DetailDialog))({
        title,
        dataMenu,
        deleted,
        approved,
        tabShow,
        access,
        handleGetList,
        ...options,
    });
}
